import { handleActions } from '@housinganywhere/safe-redux';

import { Actions, ActionTypes } from './actions';
import { HermesState } from './types';

export const initialState = {
  info: undefined,
  data: undefined,
  error: false,
};

const reducer = handleActions<HermesState, ActionTypes, Actions>(
  {
    [ActionTypes.START]: state => ({
      ...state,
      error: false,
    }),
    [ActionTypes.DONE]: (state, { payload }) => ({
      ...state,
      ...payload,
      error: false,
    }),
    [ActionTypes.FAIL]: () => ({
      ...initialState,
      error: true,
    }),
  },
  initialState,
);

export default reducer;
